/* eslint-disable max-classes-per-file */
export interface TaskMessageCompilationEntity {
    Base: {
        MessageType: "Fragment_CreateCompilation";
        TaskId: number;
        UserId: number;
    };
    FragmentId: number;
    SourceFragmentIds: number[];
    ThumbnailFileId: number;
    ThumbnailTime: number;
}

export interface TaskMessageThumbnailEntity {
    Base: {
        MessageType: "Fragment_UpdateThumbnail";
        TaskId: number;
        UserId: number;
    };
    FragmentId: number;
    ThumbnailFileId: number;
    ThumbnailTime: number;
}
export interface TaskMessageOtherEntity {
    Base: {
        MessageType: "Fragment_UpdateThumbnail";
        TaskId: number;
        UserId: number;
    };
    FragmentId: number;
}
export interface TaskMessageCreateFragmentEntity {
    Base: {
        MessageType: "CreateFragment";
        TaskId: number;
        UserId: number;
    };
    FragmentId: number;
}

export interface TaskMessagePublishEntity {
    Base: {
        MessageType: "Fragment_Publish";
        TaskId: number;
        UserId: number;
    };
    FormatKey: string;
    FragmentId: number;
    Operation: string;
    Parameters: string;
    PublishSettingKey: string;
}
export interface TaskMessageAddVariantEntity {
    Base: {
        MessageType: "Fragment_AddVariant";
        TaskId: number;
        UserId: number;
    };
    FormatKey: string;
    FragmentId: number;
}
export interface TaskMessageEditEntity {
    Base: {
        MessageType: "Fragment_CreateEdit";
        TaskId: number;
        UserId: number;
    };
    CropSettings: {
        CropHeight: number;
        CropLeft: number;
        CropTop: number;
        CropWidth: number;
        Start: number;
    };
    FontColor: string;
    FontLeft: number;
    FontSize: number;
    FontTop: number;
    FragmentId: number;
    MediaFileFontKey: string;
    MediaFileIntroKey: string;
    MediaFileOutroKey: string;
    MediaFileOverlayKey: string;
    OverlayText: string;
    SourceFragmentId: number;
    TargetHeight: number;
    TargetWidth: number;
    ThumbnailFileId: number;
    ThumbnailTime: number;
    TrimEnd: number;
    TrimStart: number;
    UsePadding: boolean;
}

export interface TaskResultArray {
    result: boolean;
    logMessages: { traceId: string; level: string; message: string }[];
}

export interface TaskEntity {
    id: number;
    projectId: number;
    message: string;
    results: TaskResultArray[];
    processing: boolean;
    insertionDate: Date;
    modifiedDate: Date;
}

export class CompilationTask {
    base: {
        messageType: "Fragment_CreateCompilation";
        taskId: number;
        userId: number;
    };

    fragmentId: number;

    sourceFragmentIds: number[];

    thumbnailFileId: number;

    thumbnailTime: number;

    constructor(entity: TaskMessageCompilationEntity) {
        this.base = {
            messageType: entity.Base.MessageType,
            taskId: entity.Base.TaskId,
            userId: entity.Base.UserId,
        };
        this.fragmentId = entity.FragmentId;
        this.sourceFragmentIds = entity.SourceFragmentIds;
        this.thumbnailFileId = entity.ThumbnailFileId;
        this.thumbnailTime = entity.ThumbnailTime;
    }
}
export class ThumbnailTask {
    base: {
        messageType: "Fragment_UpdateThumbnail";
        taskId: number;
        userId: number;
    };

    fragmentId: number;

    thumbnailFileId: number;

    thumbnailTime: number;

    constructor(entity: TaskMessageThumbnailEntity) {
        this.base = {
            messageType: entity.Base.MessageType,
            taskId: entity.Base.TaskId,
            userId: entity.Base.UserId,
        };
        this.fragmentId = entity.FragmentId;
        this.thumbnailFileId = entity.ThumbnailFileId;
        this.thumbnailTime = entity.ThumbnailTime;
    }
}
export class OtherTask {
    base: {
        messageType: "other";
        taskId: number;
        userId: number | undefined;
    };

    fragmentId: number | undefined;

    constructor(taskId: number, userId?: number, fragmentId?: number) {
        this.base = {
            messageType: "other",
            taskId,
            userId,
        };
        this.fragmentId = fragmentId;
    }
}
export class CreateFragmentTask {
    base: {
        messageType:
            | "CreateFragment"
            | "Fragment_CreateFromSelections"
            | "Fragment_CreateFromFile";
        taskId: number;
        userId: number;
    };

    fragmentId: number;

    constructor(entity: TaskMessageCreateFragmentEntity) {
        this.base = {
            messageType: entity.Base.MessageType,
            taskId: entity.Base.TaskId,
            userId: entity.Base.UserId,
        };
        this.fragmentId = entity.FragmentId;
    }
}
export class PublishTask {
    base: {
        messageType: "Fragment_Publish";
        taskId: number;
        userId: number;
    };

    formatKey: string;

    fragmentId: number;

    operation: string;

    parameters: string;

    publishSettingKey: string;

    constructor(entity: TaskMessagePublishEntity) {
        this.base = {
            messageType: entity.Base.MessageType,
            taskId: entity.Base.TaskId,
            userId: entity.Base.UserId,
        };
        this.formatKey = entity.FormatKey;
        this.fragmentId = entity.FragmentId;
        this.operation = entity.Operation;
        this.parameters = entity.Parameters;
        this.publishSettingKey = entity.PublishSettingKey;
    }
}
export class AddVariantTask {
    base: {
        messageType: "Fragment_AddVariant";
        taskId: number;
        userId: number;
    };

    formatKey: string;

    fragmentId: number;

    constructor(entity: TaskMessageAddVariantEntity) {
        this.base = {
            messageType: entity.Base.MessageType,
            taskId: entity.Base.TaskId,
            userId: entity.Base.UserId,
        };
        this.formatKey = entity.FormatKey;
        this.fragmentId = entity.FragmentId;
    }
}
export class EditTask {
    base: {
        messageType: "Fragment_CreateEdit";
        taskId: number;
        userId: number;
    };

    cropSettings: {
        cropHeight: number;
        cropLeft: number;
        cropTop: number;
        cropWidth: number;
        start: number;
    };

    fontColor: string;

    fontLeft: number;

    fontSize: number;

    fontTop: number;

    fragmentId: number;

    mediaFileFontKey: string;

    mediaFileIntroKey: string;

    mediaFileOutroKey: string;

    mediaFileOverlayKey: string;

    overlayText: string;

    sourceFragmentId: number;

    targetHeight: number;

    targetWidth: number;

    thumbnailFileId: number;

    thumbnailTime: number;

    trimEnd: number;

    trimStart: number;

    usePadding: boolean;

    constructor(entity: TaskMessageEditEntity) {
        this.base = {
            messageType: entity.Base.MessageType,
            taskId: entity.Base.TaskId,
            userId: entity.Base.UserId,
        };

        this.cropSettings = {
            cropHeight: entity.CropSettings.CropHeight,
            cropLeft: entity.CropSettings.CropLeft,
            cropTop: entity.CropSettings.CropTop,
            cropWidth: entity.CropSettings.CropWidth,
            start: entity.CropSettings.Start,
        };
        this.fontColor = entity.FontColor;
        this.fontLeft = entity.FontLeft;
        this.fontSize = entity.FontSize;
        this.fontTop = entity.FontTop;
        this.fragmentId = entity.FragmentId;
        this.mediaFileFontKey = entity.MediaFileIntroKey;
        this.mediaFileIntroKey = entity.MediaFileIntroKey;
        this.mediaFileOutroKey = entity.MediaFileOutroKey;
        this.mediaFileOverlayKey = entity.MediaFileOverlayKey;
        this.overlayText = entity.OverlayText;
        this.sourceFragmentId = entity.SourceFragmentId;
        this.targetHeight = entity.TargetHeight;
        this.targetWidth = entity.TargetWidth;
        this.thumbnailFileId = entity.ThumbnailFileId;
        this.thumbnailTime = entity.ThumbnailTime;
        this.trimEnd = entity.TrimEnd;
        this.trimStart = entity.TrimStart;
        this.usePadding = entity.UsePadding;
    }
}
export type TaskMessage = {
    type: string;
    data:
        | EditTask
        | CompilationTask
        | PublishTask
        | ThumbnailTask
        | CreateFragmentTask
        | AddVariantTask
        | OtherTask;
};
export type TaskType =
    | "duplicate"
    | "trim"
    | "crop"
    | "resize"
    | "addons"
    | "compilation"
    | "upload"
    | "thumbnail"
    | "createFragment"
    | "publish"
    | "variant"
    | "other";

export default class Task {
    id: number;

    projectId: number;

    message: TaskMessage;

    results: TaskResultArray[];

    processing: boolean;

    insertionDate: Date;

    modifiedDate: Date;

    constructor(entity: TaskEntity) {
        this.id = entity.id;
        this.projectId = entity.projectId;
        if (entity.message !== "") {
            const msg = JSON.parse(entity.message);
            let messageData;
            switch (msg.Base.MessageType) {
                case "Fragment_CreateCompilation":
                    messageData = new CompilationTask(msg);
                    break;
                case "Fragment_CreateEdit":
                    messageData = new EditTask(msg);
                    break;
                case "Fragment_Publish":
                    messageData = new PublishTask(msg);
                    break;
                case "Fragment_UpdateThumbnail":
                    messageData = new ThumbnailTask(msg);
                    break;
                case "CreateFragment":
                    messageData = new CreateFragmentTask(msg);
                    break;
                case "Fragment_CreateFromSelections":
                    messageData = new CreateFragmentTask(msg);
                    break;
                case "Fragment_CreateFromFile":
                    messageData = new CreateFragmentTask(msg);
                    break;
                case "Fragment_AddVariant":
                    messageData = new AddVariantTask(msg);
                    break;
                default:
                    messageData = new OtherTask(
                        msg.Base.TaskId,
                        msg.Base.UserId,
                        msg.fragmentId,
                    );
            }
            this.message = {
                type: msg.Base.MessageType,
                data: messageData,
            };
        } else {
            this.message = {
                type: "other",
                data: new OtherTask(entity.id),
            };
        }
        this.results = entity.results;
        this.processing = entity.processing;
        this.insertionDate = new Date(entity.insertionDate);
        this.modifiedDate = new Date(entity.modifiedDate);
    }

    getType = (): TaskType => {
        const msgType = this.message.data.base.messageType;
        const msgData = this.message.data;
        switch (msgType) {
            case "CreateFragment":
                return "createFragment";
            case "Fragment_CreateFromSelections":
                return "createFragment";
            case "Fragment_CreateFromFile":
                return "createFragment";
            case "Fragment_Publish":
                return "publish";
            case "Fragment_UpdateThumbnail":
                return "thumbnail";
            case "Fragment_CreateCompilation":
                return "compilation";
            case "Fragment_AddVariant":
                return "variant";
            case "Fragment_CreateEdit":
                if (
                    msgData instanceof EditTask &&
                    (msgData.trimEnd !== 0 || msgData.trimStart !== 0)
                ) {
                    return "trim";
                }
                if (
                    msgData instanceof EditTask &&
                    msgData.cropSettings.cropHeight
                ) {
                    return "crop";
                }
                if (
                    msgData instanceof EditTask &&
                    (msgData.mediaFileIntroKey ||
                        msgData.mediaFileOverlayKey ||
                        msgData.mediaFileOutroKey)
                ) {
                    return "addons";
                }
                if (
                    msgData instanceof EditTask &&
                    msgData.cropSettings &&
                    msgData.usePadding
                ) {
                    return "resize";
                }
                return "duplicate";

            default:
                return "other";
        }
    };
}
